import { render, staticRenderFns } from "./sevrice.vue?vue&type=template&id=710ff6dd&"
import script from "./sevrice.vue?vue&type=script&lang=js&"
export * from "./sevrice.vue?vue&type=script&lang=js&"
import style0 from "./sevrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('710ff6dd')) {
      api.createRecord('710ff6dd', component.options)
    } else {
      api.reload('710ff6dd', component.options)
    }
    module.hot.accept("./sevrice.vue?vue&type=template&id=710ff6dd&", function () {
      api.rerender('710ff6dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sevrice.vue"
export default component.exports